import { Pipe, PipeTransform } from '@angular/core';
import { Project } from '@wilson/interfaces';

@Pipe({
  name: 'projectName',
  standalone: false,
})
export class ProjectNamePipe implements PipeTransform {
  transform(
    value: Pick<Project, 'projectId' | 'name' | 'shortName'> | null | undefined,
    showShortName = false,
  ): string | null {
    if (value) {
      return `${value.projectId} - ${value.name}${showShortName && value.shortName ? ' - ' + value.shortName : ''}`;
    } else {
      return null;
    }
  }
}
